import * as React from 'react';
import { useAuthStore } from '@/auth';
import { Changepassword } from '@/shared/i18n';

import { ResetPasswordPayload } from '../types';
import { update } from '../service/update-password';
import { useUpdatePasswordStore } from '../stores/update-password-store';
import { isLeft, isRight } from '@shared-commons/utils';
import { Auth } from 'firebase/auth';
import { ChangePasswordEventKeys, ChangePasswordEvents } from '../events';
import { EventBus } from '@/shared/utils';

export const useUpdatePassword = (
  auth: Auth,
  dict: Changepassword,
  eventBus: EventBus<ChangePasswordEvents>,
) => {
  const { user } = useAuthStore();
  const { setIsLoading, setError, setActionFeedback } = useUpdatePasswordStore();

  const updatePassword = React.useCallback(
    async (payload: ResetPasswordPayload) => {
      setIsLoading(true);
      const accessToken = await auth.currentUser!.getIdToken(true);
      const result = await update({ ...payload, email: user?.email }, accessToken)();
      if (isRight(result)) {
        setIsLoading(false);
        setActionFeedback({
          message: dict.change_password.success_message,
          type: 'success',
        });
        eventBus.emit(ChangePasswordEventKeys.redirect.to, '/auth/login');
      } else if (isLeft(result)) {
        const error = new Error(result.value?.message || dict.change_password.error_message);
        setError(error);
        setIsLoading(false);
        setActionFeedback({
          message: error.message,
          type: 'danger',
        });
      }
    },
    [eventBus, auth, user?.email, dict, setError, setIsLoading, setActionFeedback],
  );

  return { updatePassword };
};
